import React, { useState } from 'react'

import { ActionButton } from 'components/common/buttons'

import { AppBar } from '@material-ui/core'
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'

import { history } from 'helpers/history'

import ContactList from './ContactList'
import useFetchData from 'hooks/fetch-data'
import { get, isEmpty } from 'lodash'
import WorkOrderList from './WorkOrderList'
import Sites from './Sites'
import facilities from 'Services/facilities'
import { getApplicationStorageItem } from 'helpers/getStorageItem'

function CompanyDetail({ companyId, companybranchId }) {
  const [selected, setTab] = useState('CO')

  const {
    loading,
    data: companyData,
    reFetch,
  } = useFetchData({
    fetch: facilities.company.get,
    payload: { companyId: getApplicationStorageItem('companyId'), clientCompanyId: companyId, pageindex: 0, pagesize: 0, searchString: null },
    formatter: d => get(d, 'data.list', []),
    defaultValue: [],
  })

  const {
    loading: companyLoading,
    data: clientCompanies,
    reFetch: callClientCompanies,
  } = useFetchData({
    fetch: facilities.company.get,
    payload: { companyId: getApplicationStorageItem('companyId'), companybranchId: companybranchId, pageindex: 0, pagesize: 0, searchString: '' },
    formatter: d => get(d, 'data.list', []),
    externalLoader: true,
    defaultValue: [],
  })

  const formatStateData = d => {
    let sortedList = []
    if (!isEmpty(d)) {
      sortedList = d.map(item => ({
        ...item,
        label: item.stateName,
        value: item.stateId,
      }))
    }
    return sortedList
  }

  const { loading: stateLoading, data: stateData } = useFetchData({ fetch: facilities.getAllStateList, payload: { searchString: null }, formatter: d => formatStateData(get(d, 'data.stateList', [])), defaultValue: [], externalLoader: true })

  const woState = {
    pageRows: get(history, 'location.state.pageRows', 20),
    search: get(history, 'location.state.search', ''),
    pageIndex: get(history, 'location.state.pageIndex', 1),
  }

  return (
    <div style={{ height: 'calc(100vh - 128px)', padding: '20px', background: '#fff' }}>
      <div className='d-flex align-items-center'>
        <div className='mr-2'>
          <ActionButton action={() => history.push({ pathname: '/facilities', state: woState })} icon={<ArrowBackIcon fontSize='small' />} tooltip='GO BACK' />
        </div>
        <div className='text-bold text-md mr-2'>{get(companyData[0], 'clientCompanyName', '')}</div>
      </div>
      <div className='assets-box-wraps customtab' style={{ marginTop: '10px' }}>
        <AppBar position='static' color='inherit'>
          <Tabs id='controlled-tab-example' activeKey={selected} onSelect={k => setTab(k)}>
            <Tab eventKey='CO' title='Contacts' tabClassName='font-weight-bolder small-tab'></Tab>
            <Tab eventKey='SO' title='Facilities' tabClassName='font-weight-bolder small-tab'></Tab>
            <Tab eventKey='WO' title='Work Orders' tabClassName='font-weight-bolder small-tab'></Tab>
          </Tabs>
        </AppBar>
      </div>
      <div style={{ height: 'calc(100vh - 128px)', position: 'relative', marginTop: '20px' }}>
        {selected === 'CO' && <ContactList obj={{ clientCompanyId: companyId }} />}
        {selected === 'SO' && <Sites companyId={companyId} loading={loading} siteList={get(companyData[0], 'listOfSite', '')} clientCompanies={clientCompanies} stateData={stateData} reFetch={reFetch} />}
        {selected === 'WO' && <WorkOrderList companyId={companyId} />}
      </div>
    </div>
  )
}

export default CompanyDetail
